import { Store, StoreConfig } from "@datorama/akita";
import { Injectable } from "@angular/core";
import { User } from "../models/user.model";

@Injectable({ providedIn: "root" })
@StoreConfig({ name: "user" })
export class UserStore extends Store<User> {
  constructor() {
    super({});
  }
}
